import React, { useState } from 'react'

import Modal from "../reusable/modal"

const WriteInstructions = ({ toggle, visible, onClose, onSave, pre = null }) => {
    const [instruction, setInstruction] = useState(pre)

    const close = () => {
        toggle()
        setTimeout(onClose, 200)
    }

    return (
        <Modal
            w={ 400 }
            align="items-start"
            top="mt-10"
            bottom="pb-10"
            title="Write Instructions"
            toggle={ close }
            visible={visible}>
            <div className="divide-y divide-light-gray-400">
                <div>
                    <p className="font-bold my-3">Instructions</p>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-instructions"
                        rows="6"
                        value={ instruction }
                        onChange={ e => setInstruction(e.target.value) }
                        placeholder="Write instructions here" />
                </div>
            </div>
            <div className="flex justify-end mt-2">
                <button onClick={ () => {
                    onSave(instruction)
                    close()
                } } type="submit" className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Instructions</button>
                <button onClick={ close } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
}

export default WriteInstructions